import {PayloadAction, createSlice} from '@reduxjs/toolkit'
import {PaymentState, FetchPaymentsResponse, FetchPaymentByIdResponse} from './types'
import {
  fetchPaymentById,
  fetchPayments,
  createPayment,
  updatePayment,
  deletePayment,
} from './service'

const initialState: PaymentState = {
  paymentForEdit: null,
  payments: [],
  total: 0,
  totalPages: 0,
  progress: 0,
  listLoading: false,
  actionLoading: false,
  error: null,
}

const paymentSlice = createSlice({
  name: 'payment',
  initialState,
  reducers: {
    handleRequestProgress: (state: PaymentState, action: any) => {
      const {progress} = action.payload
      state.progress = progress
    },
    resetPayments: (state: PaymentState) => {
      state.payments = []
      state.total = 0
      state.totalPages = 0
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchPayments.pending, (state: PaymentState) => {
      state.listLoading = true
      state.error = null
    })
    builder.addCase(fetchPayments.rejected, (state: PaymentState, action: PayloadAction<any>) => {
      const {error} = action.payload
      state.error = error
      state.listLoading = false
    })
    builder.addCase(
      fetchPayments.fulfilled,
      (state: PaymentState, action: PayloadAction<FetchPaymentsResponse>) => {
        const {payments, total, totalPages} = action.payload
        state.payments = payments
        state.total = total
        state.totalPages = totalPages
        state.listLoading = false
      }
    )

    builder.addCase(fetchPaymentById.pending, (state: PaymentState) => {
      state.actionLoading = true
      state.error = null
    })
    builder.addCase(
      fetchPaymentById.rejected,
      (state: PaymentState, action: PayloadAction<any>) => {
        const {error} = action.payload
        state.error = error
        state.actionLoading = false
      }
    )
    builder.addCase(
      fetchPaymentById.fulfilled,
      (state: PaymentState, action: PayloadAction<FetchPaymentByIdResponse>) => {
        const {payment} = action.payload
        state.paymentForEdit = payment
        state.actionLoading = false
      }
    )

    builder.addCase(createPayment.pending, (state: PaymentState) => {
      state.actionLoading = true
      state.error = null
    })
    builder.addCase(createPayment.rejected, (state: PaymentState, action: PayloadAction<any>) => {
      const {error} = action.payload
      state.error = error
      state.actionLoading = false
    })
    builder.addCase(createPayment.fulfilled, (state: PaymentState, action: PayloadAction<any>) => {
      const {payment} = action.payload
      state.payments.unshift(payment)
      state.total += 1
      state.actionLoading = false
    })

    builder.addCase(updatePayment.pending, (state: PaymentState) => {
      state.actionLoading = true
      state.error = null
    })
    builder.addCase(updatePayment.rejected, (state: PaymentState, action: PayloadAction<any>) => {
      const {error} = action.payload
      state.error = error
      state.actionLoading = false
    })
    builder.addCase(updatePayment.fulfilled, (state: PaymentState, action: PayloadAction<any>) => {
      const {payment} = action.payload
      const index = state.payments.findIndex((p) => p._id === payment._id)
      if (index !== -1) {
        state.payments[index] = payment
      }
      state.actionLoading = false
    })

    builder.addCase(deletePayment.pending, (state: PaymentState) => {
      state.actionLoading = true
      state.error = null
    })
    builder.addCase(deletePayment.rejected, (state: PaymentState, action: PayloadAction<any>) => {
      const {error} = action.payload
      state.error = error
      state.actionLoading = false
    })
    builder.addCase(deletePayment.fulfilled, (state: PaymentState, action: PayloadAction<any>) => {
      const {payment} = action.payload
      state.payments = state.payments.filter((p) => p._id !== payment._id)
      state.total -= 1
      state.actionLoading = false
    })
  },
})

export const actions = paymentSlice.actions
export default paymentSlice.reducer
